/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
import { environment } from './environment.js';
/**
 * A simple debug utility available in dev mode.
 */
export function debug(prefix) {
    if (environment.production) {
        return () => { };
    }
    return (message, ...optionalParams) => {
        if (optionalParams.length > 0) {
            // eslint-disable-next-line no-console
            console.log(`[${prefix}] ${message}`, optionalParams);
        }
        else {
            // eslint-disable-next-line no-console
            console.log(`[${prefix}] ${message}`);
        }
    };
}
//# sourceMappingURL=debug.js.map